import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";
import type { InvoiceInitializeResponse } from "../types";

export const INVOICE_INITIALIZE_KEY = "invoice-initialize";

export function useInitializeInvoiceService(invoice: string) {
  return useQuery<InvoiceInitializeResponse>({
    queryKey: [INVOICE_INITIALIZE_KEY, invoice],
    queryFn: async () => {

      const res = await axiosInstance().get(
        `account/invoices/${invoice}?include=lineItems`,
      );
      return res.data;
    },
    enabled: !!invoice,
    staleTime: Infinity,
    retry: false,
  });
}
